import { defaultLeaflet } from '@/conf/leaflet'
import { L, LMap, LMarker, LTileLayer, LIcon } from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
  },

  data () {
    return {
      leaflet: defaultLeaflet,
      markers: [],
      isShownMap: false,
      mapObject: null,
      center: [37,7749, -122,4194]
    }
  },

  created () {
    if (window.innerWidth >= 1200) {
      this.isShownForm = false
      this.isShownMap = true
    }
  },

  methods: {
    updateMap (offers) {

      // remove current markers
      for (let marker of this.markers) {
        marker.remove()
      }
      this.markers = []

      // récupération des hôtels de toutes les listes
      let hotels = []
      Object.keys(offers).forEach(key => {
        hotels.push(...offers[key].hotels)
      })

      // create new markers
      if (hotels !== null && hotels.length) {
        for (let offer of hotels) {
          let geopos = offer.hotel.geoPosition
          let latlng = L.latLng(geopos.latitude, geopos.longitude)
          let marker = new L.Marker(latlng, { draggable: false })

          // nécessaire pour l'utilisation du this dans le "onclick"
          let self = this

          //marker.addTo(this.$refs.hotelmap.mapObject)
          marker.addTo(this.mapObject)
          marker.bindPopup(offer.hotel.hotelName)
          marker.on('click', function (event) {
            self.onMarkerClicked(offer.hotelKey)
          })

          offer.markerLeafletId = marker._leaflet_id

          this.markers.push(marker)
        }
      }

      // Add marker for search position
      let geopos = null
      let favorite = this.$store.state.research.favorite
      let destination = this.$store.state.research.destination
      let fav = null

      if (favorite.location || favorite.hotel) {
        fav = favorite.hotel ? favorite.hotel : favorite.location

          geopos = {
            latitude: fav.geo_lat,
            longitude: fav.geo_lng
          }
        } else {
          geopos = destination.geoPosition
        }

        if (geopos !== null && geopos.latitude && geopos.longitude) {
          let latlng = L.latLng(geopos.latitude, geopos.longitude)
          let marker = new L.Marker(
            latlng,
            {
              draggable: false,
              zIndexOffset: 100,
              icon: L.icon({
                iconUrl: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAFlklEQVRYhcWXb2gdZRrFf+dyuYRLKJfQ1RBDKJNSSgil3LnUUkoVQRFla12qLpXuqrWohCqiQaSISCn9ICpF3ahtdUVkRd1u6cp+2VKllCph5iKlBCnNUEIIQW0IIYRwueT44R1jGpP+UaTvt5l553nOe54z53lGxtzIVbih2YHi9WwersYrJa3H7jX8CWgBZgU/GM4B33bX0x+vJ6auVoKsGrcgrQb+DmzFbrPUKrtoKEiaMzQF09gTlo4LPsS+ENXT2d8FYLgat0t6CvtxQwdSUzBie0gwAcwCLYY2QQ9SF4HVMduHgYHuejr+mwBkcS2yfUDSVqDF9gVJr9kelDQKTAMNoAS0Ap3ABuA5YDUwi30MaW+UJtl1Aciq8WrDfyT1GkYEbwLvRGkyfaXT5Ky1SnrS9h4FRs4Z7u9OkwvXBCCLa+3AQcODghHsZ5D+F6VJYziulbHXSdoM3Eyg+5LtIUlfRWkykcco2b4H6aCgy/CpYE+UJt9fEcBwNS5Jet6wVzCJ/azhc0lFwwbBS4b12CsklWwXkBqCGSAD3gU+jdJkMotrBcN2wRtABXuf4fXuetpYCOAyH5C0FvspQcn2QaRjklqAx7A/A+4CCkgngfeR3pP9hWEcqAIDwP4srnVEaTInOAYctF1C6pO0djEDi43oIaROYETS4ShNGsBWwz5JNwEnBDuBXUCfoA9pt+Ah4B3CV/EY0J/FtRX5+4eBEYJIH1gWwHBcqxj+amja3h+lyUQW13qx38auAO9j/zkH0QFsM/wNWE9gYA/wBDCD/TThGbkuDgBNw46sGleWBKBAYQUYlZRkca0F2I1UEZwB9iMVDI8bPgP+BRwB/m0YwO4APgH+me/ry+JaJa/toGEUqCBVlytBD1AWDAHj2Ktsb7I9DXyAPWr7Qez92BFQwAa7gr0NeNV2m+EQ9nnsLuD2PPa4YEhQtt2zJADbt+hnF4MppE7BKqRx4AxSK/CEpLZ51iSQkFRAulvSFuwxpDP5V3Jrzu607TGgiHTLcgyUbReBGdlNgrutwJ5GGscuCXrnEy9aDnsjghBDMrgpP11D0gxQlF1eEoCkBjAHlJCK+c2FCcgFuihzuBb83JTm40qay+MUgZJhDumyBlVYEOgSUhNoA8qE7jalQH0Hoe0mkuaty5eDnJB03sE3OnKwP4bQLhvaCMxeWhqA9J1g1vaaHMQI0kXsdmCTpBnDgGF0PmUQIXngo8ApQaftjbIbSF/nTKyUvUahPOeXBgBJLr61hFpfBE5bKhseBbokHQeeAb4BpiQ1kDLDe8CLhAS7Ja1Buig4lTPVg7QWaQpIlgMwJkgELdi7chc7JJiUvRH7JaDUnSZHgZ3Y99m+F/sBSS8AU8AO7EdsN7HfjtJkEkD2LkLchCDQX4hf2IyyuLYF+K/D5oclHQW2G94UrHQ40Wuy68AkQWStQBfQh73DQRNvCfYRdLQd+CgX371RmpxeCOCymdBwVnBcsAOpP6/XF4IVwD7ZtyOts1RXOEkTWIndg7TaQcT/ELwRpcnUcFxbBzwnqZgPJ2dZtJaaB6qGI4J1tk9K2m17TMFC9wI1gmWHmRCauVdcMAwoiHGaMAcckn0HcBZ4NKqn314VAMBwXLtL9odAO9IZ4GUC/QVDj2AzcLODOf1gGJJ0KkqTqawal5C2AK/Y3iRp3PbO7np64leJFpfgl1r4BFI/9gFgo+0jko4Br3anSR2oL/VaFtc6Qf3ANuxOSaO2XxScXDLPcgwsCNhLaDKbc0OaAQYN/8e+CEwjtQpWGe5UGErLhAZ2Gqk/SpNzyya4GoAcRDvwF+BhYCNX/ptqYg8CHyMdjdLkiiP5NQEAyKpxkdAFe4HbsDcgtRMa2IxgHGkQ+DIfUCeiNGleNfC1Avgj1w3/Ob3hAH4CDsXFYb9wxqsAAAAASUVORK5CYII=',
                iconSize: [32, 32],
                iconAnchor: [16, 16]
              }),
            }
          )

          let locationName = ''

          if (fav) {
            locationName = fav.name
          } else {
            locationName = destination.locationName
          }

          marker.bindPopup(locationName)
          marker.addTo(this.mapObject)
          this.markers.push(marker)
        }

        // recompute center and zoom
        let group = new L.featureGroup(this.markers)
	this.$nextTick( function () {
		// Compute map
		//this.isShownMap = true
		this.mapObject.invalidateSize()
		this.mapObject.fitBounds(group.getBounds(), { padding: [10, 10] })
	});
    },

    onMarkerClicked (hotelKey) {
      // On réinitialise les hôtels séléctionnés
      for (let offerType in this.offers) {
        for (let offerId in this.offers[offerType]["hotels"]) {
          let offer = this.offers[offerType]["hotels"][offerId];
          offer.selected = false;

          // On séléctionne celui qui a été cliqué
          if (offer.hotelKey == hotelKey)
            offer.selected = true
        }
      }

      // On scroll
      this.$refs[hotelKey][0].$el.scrollIntoView({
        block: "center",
        behavior: "smooth"
      });

      // On doit forceUpdate car vue ne détecte pas la modification sur les offers
      this.$forceUpdate();
    },

    updateOpenMarker (offer) {
      let marker = this.markers.find(function (marker) {
        return marker._leaflet_id === offer.markerLeafletId
      })

      marker.openPopup()
    },

    toggleMap: function(event) {
        this.isShownMap = !this.isShownMap
	if(!this.isShownMap) return
        let group = new L.featureGroup(this.markers)
	this.$nextTick( function () {
          this.mapObject.invalidateSize()
	  this.mapObject.fitBounds(group.getBounds(), { padding: [10, 10] })
        });
    }

  },

  computed: {
    mapMessage () {
      return this.$t(
        this.isShownMap ? '_hide_map' : '_show_map'
      )
    }
  }
}
